import {authHeader, handleResponsePublic as handleResponse} from '../_helpers';

export const claudeService = {
  launch,
  history,
  logs,
  cancel,
  cancelBatch,
  retry,
  retryBatch,
  deleteBatch,
  delete: _delete
};

async function launch(model, action, prompt, checked_items) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify({ "mode": "list", "model": model,  "action": action, "prompt": prompt, "ids": checked_items })
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/launch`, requestOptions).then(handleResponse);
}

async function history(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/history${api_params}`, requestOptions).then(handleResponse);
}

async function logs(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/logs${api_params}`, requestOptions).then(handleResponse);
}

async function cancel(ids) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify({ "ids": ids })
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/cancel`, requestOptions).then(handleResponse);
}

async function cancelBatch(batchId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/cancel-batch/${batchId}`, requestOptions).then(handleResponse);
}

async function retry(ids) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify({ "ids": ids })
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/retry`, requestOptions).then(handleResponse);
}

async function retryBatch(batchId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/retry/${batchId}`, requestOptions).then(handleResponse);
}

async function deleteBatch(batchId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/batch/${batchId}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function _delete(ids) {
  const requestOptions = {
    method: 'DELETE',
    cache: 'no-store',
    headers: authHeader(),
    body: JSON.stringify({ "ids": ids })
  };

  return fetch(`${process.env.REACT_APP_API_URL}/claude-batch/delete`, requestOptions).then(handleResponse);
}